// extracted by mini-css-extract-plugin
export default {"saveBtn":"TermsAndConditions_saveBtn__GL5-h","privacyPolicy":"TermsAndConditions_privacyPolicy__+LdwB"};